import { LoadingController } from '@ionic/angular';
import { Translate } from 'src/shared/translate';

export class AppBase {

    loader: HTMLIonLoadingElement;

    constructor(public loading: LoadingController) {
    }

    async initLoader(message?: string, duration?: number) {
        if (!message)
            message = Translate.getTranslation("LoadingMessage")
        if (!duration)
            duration = 15000

        this.loader = await this.loading.create({
            spinner: 'crescent',
            message: message,
            duration: duration,
            mode: 'ios'
        });
    }

    isLoaderInitialized(){
        if (this.loader)
            return true;
        else
            return false;
    }

    showLoader() {
        if (this.loader)
            this.loader.present()
    }

    hideLoader() {
        if (this.loader)
            this.loader.dismiss()
    }

}